import { createBlock } from 'factories/block';
import { InteractionProps } from './interaction';
import { colors } from 'styles/variables';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createEditableBtn } from './editableBtn';
import { createMediaBlock } from './media';
import hotspotDefaultSVG from 'assets/HotspotDefault_v3.svg';

const { lPink } = colors;

export type HotSpotInteractionProps = InteractionProps & {
  answerCount: number;
};

// should add the option to include image in ' popUp '
// ? createFeedbackBlock({}) : ...
const createHotSpotElement = ({ name = '', points = [], ...props }) => {
  return createBlock(
    'HotSpotElement',
    [
      createMediaBlock({
        child: 1,
      }),
      createMediaBlock({
        child: 0,
      }),
      createEditableBtn({ label: 'Continue' }),
    ],
    {
      props: {
        type: 'HotSpotElement',
        name,
        points,
        ...props,
      },
      meta: {
        subType: 'HotSpotElement',
      },
    }
  );
};

export const createHotSpotBlock = props => {
  const {
    numberOfAttempts = 1,
    lockDown = 0,
    score = false,
    image,
    hotspotType = 'circle',
    hotSpotColor = lPink,
    hotSpotSize = 50,
    hotSpots = {},
    style,
    src,
  } = props as any;

  return createBlock('HotSpotIsolated', [], {
    props: {
      name: props.name,
      style: props.style,
      numberOfAttempts,
      lockDown,
      score,
      image,
      hotspotType,
      hotSpotColor,
      hotSpotSize,
      src,
    },
    meta: {
      subType: 'HotSpotIsolated',
    },
  });
};

export const addHotSpotOption = (
  block: Block,
  position: number,
  props
): [Block, Blocks?] => {
  if (block.type === 'HotSpotIsolated') {
    const hotSpotOptionBlock = createHotSpotElement(props);

    const hotSpotOptionBlockRef = {
      id: hotSpotOptionBlock.id,
      type: 'Ref',
    };
    const [newBlocks] = flatten(hotSpotOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, hotSpotOptionBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeHotSpotOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'HotSpotIsolated') {
    const hotSpotOptionBlock = createHotSpotElement({});

    const [newBlocks] = flatten(hotSpotOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeAllHotSpotOptions = (
  block: Block
): [Block, Blocks?] | undefined => {
  if (block.type === 'HotSpotIsolated') {
    const hotSpotOptionBlock = createHotSpotElement({});

    const [newBlocks] = flatten(hotSpotOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(0);

    return [nextBlock, newBlocks];
  }
};

export const getNextHotSpotBlock = (
  block: Block
): [Block, Blocks?] | undefined => {
  if (block.type === 'HotSpotIsolated') {
    const hotSpotOptionBlock = createHotSpotElement({});

    const [newBlocks] = flatten(hotSpotOptionBlock);

    const nextBlock = cloneBlock(block);

    return [nextBlock, newBlocks];
  }
};

export const interactionConfig = {};
